import { Component, OnInit } from '@angular/core';
import { HostingService } from '../../services/hosting.service';
import { AuthService } from '../../services/auth.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { AdminHotelNavbarComponent } from '../../components/admin-hotel-navbar/admin-hotel-navbar.component';
import { NavbarComponent } from "../../components/navbar/navbar.component";
import { MatIcon } from "@angular/material/icon";
import { MatFormField, MatLabel } from "@angular/material/form-field";
import { MatMenuModule } from "@angular/material/menu";
import { MatOption } from "@angular/material/core";
import { MatSelect } from "@angular/material/select";
import { MatButtonModule } from "@angular/material/button";
import { MatDialog, MatDialogModule } from "@angular/material/dialog";
import { HostingModalComponent } from '../../components/hosting-modal/hosting-modal.component';

@Component({
  selector: 'app-admin-hotel-hostings',
  templateUrl: './admin-hotel-hostings.component.html',
  styleUrl: './admin-hotel-hostings.component.css',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    RouterLink,
    AdminHotelNavbarComponent,
    NavbarComponent,
    MatIcon,
    MatFormField,
    MatMenuModule,
    MatLabel,
    MatSelect,
    MatOption,
    MatButtonModule,
    MatDialogModule
  ]
})
export class AdminHotelHostingsComponent implements OnInit {
  hostings: any[] = [];
  is_loading = false;
  error_msg = '';

  // Paginación
  page_size = 6;
  current_page = 0;
  page_size_options = [3, 6, 9, 12];

  stats = [
    { label: 'Total Alojamientos', icon: 'apartment', value: '0', sub: '' },
    // { label: 'Reservas Activas', icon: 'calendar_today', value: '18', sub: '+5 esta semana' },
    // { label: 'Ocupación', icon: 'group', value: '75%', sub: '+12% vs mes anterior' },
    // { label: 'Ingresos', icon: 'attach_money', value: '$45.2M', sub: '+8% este mes' },
  ];

  constructor(
    private readonly hostingService: HostingService,
    private readonly authService: AuthService,
    private dialog: MatDialog,
    private readonly router: Router
  ) { }

  ngOnInit(): void {
    this.cargarAlojamientosByAdminId();
  }

  async cargarAlojamientosByAdminId() {
    this.is_loading = true;
    this.error_msg = '';
    this.hostings = await this.hostingService.getHostingsByAdminIds();
    console.log("pruebaaaaaa")
    this.is_loading = false;
  }

  // ===== PAGINACIÓN =====
  get totalPages(): number {
    return Math.ceil(this.hostings.length / this.page_size);
  }

  get paginatedHostings(): any[] {
    const startIndex = this.current_page * this.page_size;
    return this.hostings.slice(startIndex, startIndex + this.page_size);
  }

  onPageChange(page: number): void {
    this.current_page = page;
  }

  onPageSizeChange(size: number): void {
    this.page_size = size;
    this.current_page = 0;
  }

  get Math() {
    return Math;
  }

  // ===== CARGA DE DATOS =====
  async loadHostings() {
    this.is_loading = true;
    this.error_msg = '';
    try {
      const user = this.authService.getUserFromToken();
      let alojamientosIds: string[] = [];
      if (user?.['custom:alojamientos_ids']) {
        if (typeof user['custom:alojamientos_ids'] === 'string') {
          alojamientosIds = user['custom:alojamientos_ids'].split(',').map((id: string) => id.trim());
        } else {
          alojamientosIds = user['custom:alojamientos_ids'];
        }
      }
      this.hostings = await this.hostingService.getHostingsByIds(alojamientosIds);

      // Actualizar estadísticas
      this.updateStats();
    } catch (err) {
      this.error_msg = 'Error cargando alojamientos';
      console.error(err);
    } finally {
      this.is_loading = false;
    }
  }

  updateStats() {
    this.stats[0].value = this.hostings.length.toString();
  }

  // ===== ELIMINAR ALOJAMIENTO =====
  async deleteHosting(id: string) {
    if (!confirm('¿Seguro que deseas eliminar este alojamiento?')) return;
    try {
      this.is_loading = true;
      await this.hostingService.deleteHosting(id).toPromise?.();
      await this.authService.refreshToken().catch(() => { });
      this.cargarAlojamientosByAdminId();
    } catch (err) {
      this.error_msg = 'Error eliminando alojamiento';
      console.error(err);
      alert('Error al eliminar el alojamiento');
    } finally {
      this.is_loading = false;
    }
  }

  // ===== MÉTODOS AUXILIARES =====
  getAmenities(hosting: any): string[] {
    const amenities: string[] = [];
    return amenities;
  }

  getHostingImage(hosting: any): string {
    return hosting.images?.[0] || 'https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=600';
  }

  getHostingRating(hosting: any): number {
    return 4.5;
  }

  getPricing(hosting: any): string {
    const formato = new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0
    });
    if (hosting.rooms.length > 1) {
      let priceMin = 0;
      let priceMax = 0;
      const pricing = hosting.rooms.map((room: any) => room.price_per_night);
      if (pricing.length > 0) {
        priceMin = Math.min(...pricing);
        priceMax = Math.max(...pricing);
      }
      return `${formato.format(priceMin)} - ${formato.format(priceMax)}`;
    } else {
      return formato.format(hosting.rooms[0].price_per_night);
    }
  }

  // ===== MÉTODOS PARA MODAL =====

  openCreateModal(): void {
    const dialogRef = this.dialog.open(HostingModalComponent, {
      width: '90%',
      maxWidth: '900px',
      maxHeight: '90vh',
      data: { mode: 'create' },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result && result.action === 'save') {
        await this.createHosting(result.data);
      }
    });
  }

  /**
   * Abre el modal para editar un alojamiento existente
   */
  openEditModal(hosting: any): void {
    const dialogRef = this.dialog.open(HostingModalComponent, {
      width: '90%',
      maxWidth: '900px',
      maxHeight: '90vh',
      data: {
        mode: 'edit',
        hosting: hosting
      },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result && result.action === 'save') {
        await this.updateHosting(hosting.id, result.data);
      }
    });
  }

  /**
   * Crea un nuevo alojamiento
   */
    private async createHosting(hostingData: any): Promise<void> {
    try {
      this.is_loading = true;
      this.hostingService.createHosting(hostingData).subscribe({
        next: async (resp) => {
          if (resp && resp.id) {
            try {
              await this.authService.refreshToken().catch(() => { });
              alert('¡Alojamiento creado exitosamente!');
              this.cargarAlojamientosByAdminId();
            } catch (e: any) {
              alert('El alojamiento fue creado, pero no se pudo asignar al usuario: ' + (e?.message || e));
              this.cargarAlojamientosByAdminId();
            }
          }
        },
        error: (err) => {
          this.error_msg = 'Error al crear alojamiento';
          console.error(err);
          alert('Error al crear alojamiento: ' + (err?.message || 'Error desconocido'));
          this.is_loading = false;
        },
        complete: () => {
          this.is_loading = false;
        }
      });
    } catch (err) {
      this.error_msg = 'Error al crear alojamiento';
      console.error(err);
      alert('Error al crear alojamiento');
      this.is_loading = false;
    }
  }

  /**
   * Actualiza un alojamiento existente
   */
  private async updateHosting(hostingId: string, hostingData: any): Promise<void> {
    try {
      this.is_loading = true;

      this.hostingService.updateHosting(hostingId, hostingData).subscribe({
        next: async (resp) => {
          alert('¡Alojamiento actualizado exitosamente!');
          await this.authService.refreshToken().catch(() => { }); //Refresca el token (no entiendo el motivo)
          this.cargarAlojamientosByAdminId();
        },
        error: (err) => {
          this.error_msg = 'Error al actualizar alojamiento';
          alert('Error al actualizar alojamiento: ' + (err?.message || 'Error desconocido'));
          this.is_loading = false;
        },
        complete: () => {
          this.is_loading = false;
        }
      });
    } catch (err) {
      this.error_msg = 'Error al actualizar alojamiento';
      console.error(err);
      alert('Error al actualizar alojamiento');
      this.is_loading = false;
    }
  }

  //Ir a la página de creación de landing
 goToLandingPageEditor(hosting: any): void {
  // Generar slug desde nombre + ciudad
  const baseName = hosting.name;
  const city = hosting.location?.city || '';

  const fullName = city ? `${baseName} ${city}` : baseName;
  const orgId = this.sanitizeSlug(fullName);

  console.log('🏢 Navegando a landing editor:', {
    name: hosting.name,
    city: city,
    slug: orgId
  });

  // Navegar al editor
  this.router.navigate(['/admin-hotel/alojamientos', orgId, 'sitios']);
}

gestionarLandings(hosting: any): void {
  const baseName = hosting.name;
  const city = hosting.location?.city || '';
  const fullName = city ? `${baseName} ${city}` : baseName;
  const orgId = this.sanitizeSlug(fullName);

  console.log('📋 Navegando a gestión de landings:', orgId);

  this.router.navigate(['/admin-hotel/alojamientos', orgId, 'sitios']);
}

private sanitizeSlug(text: string): string {
  return text
    .toLowerCase()
    .replace(/\u00f1/g, 'n') // Reemplaza la ñ por n
    .normalize('NFD') // Descompone caracteres con acentos
    .replace(/[\u0300-\u036f]/g, '') // Quita tildes
    .replace(/[^a-z0-9]+/g, '-')      // Reemplaza caracteres especiales con guiones
    .replace(/^-+|-+$/g, '');         // Quita guiones al inicio/final
}

}
